import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import { FaXmark, FaCheck } from 'react-icons/fa6';
import {
  BackgroundImage,
  Row, Button, Column,
} from './Styles';
import Header from '../../../Common/Header';
import { Australia } from '../../../../../assets/Base64Image';
import { Cab, User } from '../../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import Logo from '../../../Common/Logo';
import Location from '../../../Common/Location';

const CreateUser: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  cab,
  setShowLoading,
  setUserId,
  setPhoneNumber,
}) => {
  const [checkPhoneValid, { loading: checkPhoneLoading }] = getFoodifoxDataLazy('/foxH5Phone/checkPhoneValid');
  const [sendVerifyCodeLazy, { loading: sendVerifyCodeLoading }] = getFoodifoxDataLazy('/foxH5Phone/sendVerifyCode');
  const [checkVerifyCodeLazy, { loading: checkVerifyCodeLoading }] = getFoodifoxDataLazy('/foxH5Phone/checkVerifyCode');
  const [createUserLazy, { loading: createLoading }] = updateFoodifoxData<User>('/foxH5User/createAndGetUserId');

  const timeWaitRef = useRef<number>();

  const [verifyPhone, setVerifyPhone] = useState<string>();
  const [verifyCode, setVerifyCode] = useState<string>();
  const [phoneCheck, setPhoneCheck] = useState<boolean>();
  const [codeCheck, setCodeCheck] = useState<boolean>();
  const [timeWait, setTimeWait] = useState<string>();
  const [codeId, setCodeId] = useState<string>();

  useEffect(() => {
    setShowLoading(checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || createLoading);

    return () => {
      setShowLoading(false);
    };
  }, [checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading, createLoading]);

  useEffect(() => {
    setInterval(() => {
      if (timeWaitRef.current != null && timeWaitRef.current <= 1) {
        timeWaitRef.current = undefined;
        setTimeWait(undefined);
        return;
      }
      if (timeWaitRef.current != null && timeWaitRef.current > 1) {
        timeWaitRef.current -= 1;
        setTimeWait(timeWaitRef.current.toFixed(0));
      }
    }, 1000);
  }, []);

  useEffect(() => {
    // 达到长度后自动触发验证验证码
    if (verifyCode != null && verifyCode.length >= 4) {
      checkVerifyCode();
    }
  }, [verifyCode]);

  /**
   * 发送验证码
   */
  const sendVerifyCode = () => {
    // 清空验证码
    setVerifyCode(undefined);

    // 倒计时没有结束时，不继续发送短信
    if (timeWaitRef.current != null && timeWaitRef.current > 0) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    // 验证手机号
    checkPhoneValid({
      param: {
        phoneNumber: verifyPhone,
        phoneCode: 'AU',
      },
      onError() {
        // 手机号码校验标识
        setPhoneCheck(false);
      },
      onCompleted() {
        // 手机号码校验标识
        setPhoneCheck(true);

        // 发送验证码
        sendVerifyCodeLazy({
          param: {
            phoneNumber: verifyPhone,
            phoneCode: 'AU',
          },
          onCompleted(resultData) {
            // 倒计时秒数
            timeWaitRef.current = 60;
            setTimeWait('60');
            // 设置验证码ID，验证验证码时需要用到
            setCodeId(resultData as any);
          },
        });
      },
    });
  };

  /**
   * 验证验证码
   */
  const checkVerifyCode = () => {
    if (verifyCode == null || verifyCode.trim().length < 4) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    checkVerifyCodeLazy({
      param: {
        id: codeId,
        code: verifyCode,
      },
      onError() {
        // 验证码校验标识
        setCodeCheck(false);
      },
      onCompleted() {
        // 验证码校验标识
        setCodeCheck(true);
      },
    });
  };

  /**
   * 创建用户
   */
  const createUser = () => {
    if (verifyCode == null || verifyCode.trim().length < 4) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    if (!codeCheck) {
      return;
    }

    createUserLazy({
      param: {
        phoneNumber: verifyPhone,
        phoneCode: 'AU',
        userAgent: navigator.userAgent,
        cabId: cabId32Str,
      },
      onCompleted(userData) {
        const { userId, phoneNumber } = userData;
        setUserId(userId);
        setPhoneNumber(phoneNumber);
        setTargetPage('select-platform');
        setShowLoading(false);
      },
    });
  };

  return (
    <BackgroundImage>
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      {/* Logo */}
      <Logo setTargetPage={setTargetPage} backToPage={'home'} />

      {/* 地点 */}
      <Location isEnglish={isEnglish} cab={cab} style={{ marginTop: '25px' }} />

      {/* 提示验证手机号 */}
      <div style={{ width: '80%', marginTop: '35px', marginLeft: '10%', marginRight: '10%', textAlign: 'center' }}>
        {
          isEnglish ? (
            <span style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '20px' }}>
              Enter your phone number to verify
            </span>
          ) : (
            <span style={{ fontSize: '14px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '20px' }}>
              输入您的手机号进行验证
            </span>
          )
        }
      </div>

      {/* 验证电话号码 */}
      <Row style={{ width: '85%', height: '72px', background: '#FFFFFF', borderRadius: '36px', border: '1px solid ' + (phoneCheck === false ? '#F00124' : '#11202B'), margin: '20px auto 0 auto', justifyContent: 'space-between' }}>
        <Row>
          <Column style={{ height: '72px', alignItems: 'center', marginLeft: '25px' }}>
            <img src={Australia} style={{ width: '22px' }} />
          </Column>
          <Column style={{ height: '72px', alignItems: 'center', width: '26px', fontSize: '18px', lineHeight: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', marginLeft: '5px' }}>
            +61
          </Column>
        </Row>
        <Column style={{ height: '72px', alignItems: 'center', width: '185px' }}>
          {
            <input
              style={{
                border: 'none',
                outline: 'none',
                fontSize: '18px',
                fontFamily: 'Squad-Regular, Squad',
                fontWeight: 400,
                color: '#11202B',
                backgroundColor: '#ffffff',
                lineHeight: '24px',
                textAlign: 'center',
                width: '130px',
              }}
              autoFocus={true}
              type="tel"
              inputMode="numeric"
              placeholder={isEnglish ? 'Your’s Mobile #' : '你的手机号 #'}
              value={verifyPhone}
              onChange={(e) => {
                //去掉所有空格，重新设置文本款过的值
                setVerifyPhone(e.target.value.replace(/\s*/g, ""));
                setPhoneCheck(undefined);
                setCodeCheck(undefined);
              }}
            />
          }
        </Column>
        <Row style={{ height: '72px', width: '53px', alignItems: 'center', justifyContent: 'flex-end', marginRight: '25px' }}>
          {
            phoneCheck && (
              <FaCheck style={{ color: '#00B595' }} />
            )
          }
          {
            phoneCheck === false && (
              <FaXmark style={{ color: '#F44336' }} />
            )
          }
        </Row>
      </Row>

      {/* 获取验证码按钮 */}
      <div id="getVerifyCodeBtnDiv">
        <Button
          disabled={createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || phoneCheck === false || timeWait != null || verifyPhone == null || verifyPhone.trim().length < 9}
          onClick={() => sendVerifyCode()}
          style={{ height: '60px', background: (createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || phoneCheck === false || timeWait != null || verifyPhone == null || verifyPhone.trim().length < 9) ? '#D0D0D0' : '#01B596', border: 'none', borderRadius: '33px', width: '60%', margin: '18px auto 0 auto', flexDirection: 'row' }}
        >
          {
            isEnglish ? (
              <span style={{ fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '29px' }}>
                Get a Code
              </span>
            ) : (
              <span style={{ fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '30px' }}>
                获取验证码
              </span>
            )
          }
          <span style={{ fontSize: '16px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px', marginLeft: '5px' }}>
            {timeWait != null ? '(' + timeWait + 's)' : ''}
          </span>
        </Button>
      </div>

      {/* 验证码 */}
      <div>
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          {
            isEnglish ? (
              <span style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '20px' }}>
                Enter the verification code you recieved from SMS
              </span>
            ) : (
              <span style={{ fontSize: '14px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '20px' }}>
                输入短信中的’验证码’
              </span>
            )
          }
        </div>
        <Row style={{ width: '85%', height: '72px', background: '#ffffff', borderRadius: '36px', border: '1px solid ' + (codeCheck === false ? '#F00124' : '#11202B'), margin: '20px auto 0 auto' }}>
          <div style={{ width: '50px' }}></div>
          <Row style={{ height: '72px', alignItems: 'center', width: '100%' }}>
            <input
              style={{
                width: '100%',
                border: 'none',
                outline: 'none',
                fontSize: '20px',
                fontFamily: 'Squad-Regular, Squad',
                fontWeight: 400,
                color: '#11202B',
                lineHeight: '26px',
                backgroundColor: '#ffffff',
                textAlign: 'center',
              }}
              type="tel"
              inputMode="numeric"
              placeholder={isEnglish ? 'Verify Code' : '验证码'}
              value={verifyCode}
              onChange={(e) => {
                let code = e.target.value.replace(/\s*/g, "");
                if (code.length > 4) {
                  code = code.substring(0, 4);
                }
                setVerifyCode(code);
                setCodeCheck(undefined);
              }}
            />
          </Row>
          <Row style={{ height: '72px', width: '14px', alignItems: 'center', marginRight: '25px' }}>
            {
              codeCheck && (
                <FaCheck style={{ color: '#00B595' }} />
              )
            }
            {
              codeCheck === false && (
                <FaXmark style={{ color: '#F44336' }} />
              )
            }
          </Row>
        </Row>
      </div>

      {/* 验证验证码按钮 */}
      <div style={{ paddingBottom: '50px' }}>
        <Button
          disabled={createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || codeCheck === false || verifyPhone == null || verifyPhone.trim().length < 9 || verifyCode == null || verifyCode.trim().length < 4}
          onClick={() => createUser()}
          style={{ height: '60px', background: (createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || codeCheck === false || verifyPhone == null || verifyPhone.trim().length < 9 || verifyCode == null || verifyCode.trim().length < 4) ? '#D0D0D0' : '#01B596', border: 'none', borderRadius: '33px', width: '60%', margin: '18px auto 0 auto' }}
        >
          {
            isEnglish ? (
              <span style={{ fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '24px' }}>
                Verify to Register
              </span>
            ) : (
              <span style={{ fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '30px' }}>
                下一步
              </span>
            )
          }
        </Button>
      </div>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  setShowLoading: (isShow: boolean) => void;
  setUserId: (userId: number) => void;
  setPhoneNumber: (phoneNumber: number) => void;
}

export default CreateUser;
